import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: 'input[inputUppercase]',
    host: {
        '(input)': 'ref.nativeElement.value=$event.target.value.toUpperCase()',
    }

})
export class inputUppercaseDirective {
    constructor(private ref: ElementRef) {
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/directives/input-uppercase.directive.ts